// extracted by mini-css-extract-plugin
module.exports = {"fade-enter-active":"ModalService_fade-enter-active_2mnf7","fade-leave-active":"ModalService_fade-leave-active_20nky"};